import styled, { css } from 'styled-components';

export const selectionSurface = css<{ $selected: boolean }>`
    border: 1px solid ${(props) => (props.$selected ? props.theme.app.component.checkbox.selected.active.border : props.theme.app.borderColor)};
    border-radius: 4px;
    background: ${(props) => (props.$selected ? props.theme.app.component.tabs.active.backgroundColor : props.theme.app.pageBackgroundColor)};
    transition:
        background 0.2s ease,
        border-color 0.2s ease;

    &:hover {
        border-color: ${(props) =>
            props.$selected ? props.theme.app.component.checkbox.selected.active.border : props.theme.app.component.checkbox.unselected.active.border};
    }
`;

export const SelectionItemName = styled.span<{ $bold?: boolean }>`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: ${(props) => (props.$bold ? 600 : 400)};
    color: ${(props) => props.theme.app.textColor};
`;
